<div class="chat-container">
  <div class="main-header">
    <div class="header-details">
      <div class="header-information">
        <img class="header-logo" src="assets/Donna.png" alt="AskHR Logo" />
        <div class="header-title">
          <div class="header-subtitle">{{botPersonlity.name}}</div>
          <div class="header-description">HR Policy Assistant</div>
        </div>
      </div>
     
    </div>
  </div>
  <div class="goodbye-message" *ngIf="fadeOutState === 'hidden'">
    <h1>
      Thank you for using AskHR
    </h1>
  </div>
  <div [@fadeOutTrigger]="fadeOutState" class="chat-messages-container">

    <div #answersContainer [attr.isLatest]="first ? true : null" *ngFor="let message of chatMessages.slice().reverse(); first as first">
      <div *ngIf="!message.isQuestion" class="chat-avatar-container-left">
        <div class="chat-bubble-avatar-left">
          <img *ngIf="message.type != COMPONENT_NAME.PREDEFINED_BUTTONS" class="bubble-logo" src="assets/Donna_Dark2.png"
            alt="AskHR Logo" />
        </div>
        <div
          [ngClass]="{'left': !message.isQuestion, 'transperant-bubble': message.type == COMPONENT_NAME.LOADER || message.type == COMPONENT_NAME.PREDEFINED_BUTTONS}"
          [class.chat-bubble]="message.type != COMPONENT_NAME.LOADER || message.type != COMPONENT_NAME.PREDEFINED_BUTTONS">
          <!-- Custom component messages-->
          <helpful-information *ngIf="message.type === COMPONENT_NAME.HELPFUL_INFORMATION"
            (onMessageAction)="handleMessageAction($event)" [text]="message.text"></helpful-information>
          <app-send-email *ngIf="message.type == COMPONENT_NAME.SEND_EMAIL"
            (onMessageAction)="handleMessageAction($event)" [text]="message.text"></app-send-email>
          <app-send-to-hr *ngIf="message.type == COMPONENT_NAME.SEND_HR" (onMessageAction)="handleMessageAction($event)"
            [text]="message.text"></app-send-to-hr>
          <app-new-conversation *ngIf="message.type == COMPONENT_NAME.NEW_CONVERSATION"
            (onMessageAction)="handleMessageAction($event)" [text]="message.text"></app-new-conversation>
          <app-answer *ngIf="message.type == COMPONENT_NAME.ANSWER" [text]="message.text"></app-answer>
          <app-loader *ngIf="message.type == COMPONENT_NAME.LOADER"></app-loader>
          <app-rate-experiance *ngIf="message.type == COMPONENT_NAME.STAR_RATING"
            (onValueChange)="handleRatingChange($event)"
            [text]="message.text"
            [disabled]="disableRatingPrompt"></app-rate-experiance>
        </div>
      </div>

      <div class="chat-avatar-container-right">
        <div *ngIf="message.type == 'question' || message.type == COMPONENT_NAME.PREDEFINED_BUTTONS" class="chat-bubble-div">
          <div class="chat-bubble right"> {{ message.text }} </div>
          <p-avatar [label]="avatarLabel" class="chat-bubble-avatar-right bubble-logo" shape="circle"
            [style]="{ 'background-color': '#ffffff', color: '#642D8F', 'font-weight': 600 }"></p-avatar>
        </div>
      </div>

    </div>

  </div>

  <div class="user-prompt-container" *ngIf="showUserPrompt">
    <div class="user-prompt-position">
      <div class="answer">
        <app-user-choise-prompt
        [confirmButton]="userPromptConfirmButton"
        [cancelButton]="userPromptCancleButton"
        [disable]="disableUserPrompt"
        (handleUserChoise)="handleUserPromptChoise($event)"
        >
        </app-user-choise-prompt>
      </div>
    </div>
  </div>

  <div class="helpfull-question-container" *ngIf="showHelpfullMessages">
    <div class="helpfull-question-position">
      <div class="helpfull-heading-container">
        <h2 class="helpfull-heading">
          <span class="helpfull-questions-title">Most common questions</span>
        </h2>
      </div>
      <div class="answer">
        <div class="helpfull-question-prompt-answer">
            <button *ngFor="let message of helpfullMessages"
              class="helpfull-question-button"
              (click)="sendPredefinedMessage(message.message)">{{message.message}}</button>
        </div>
      </div>
    </div>
  </div>


  <div class="input-container">
    <div class="input-holder">
      <form>
        <input id="input" class="chat-input" [disabled]="isInputDisabled || isAnswerReceived" type="text" onfocus="this.placeholder = ''"
          placeholder="{{ (isInputDisabled || isAnswerReceived) ? '' : 'Type your HR policy related question here ...'}}" [(ngModel)]="inputValue"
          (keyup.enter)="onEnterKey($event)" (keyup)="onKey($event)" />
        <div class="input-button"
          [ngClass]="{'no-cursor': isInputDisabled, 'disabled-button': (isInputDisabled || isAnswerReceived) }"
          (click)="onEnterKey($event)">
          <span class="material-symbols-outlined button-icon">
            send
          </span>
        </div>
      </form>
    </div>
  </div>
  <div class="disclaimer">Note:  The information provided may not be current or complete. Contact HR for precise guidance. For reporting an issue,  <u><a style="cursor: pointer; color: #662C90;" (click)="collector.showDialog()">click here</a>.</u>
    <ngx-jira-issue-collector [configuration]="config" #collector>
    </ngx-jira-issue-collector></div>
   

</div>